var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-base',[_c('div',{attrs:{"id":"upload_main"}})])}
var staticRenderFns = []

export { render, staticRenderFns }